/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GovernanceCustomQuestionnaire } from './GovernanceCustomQuestionnaire';
import {
  GovernanceCustomQuestionnaireFromJSON,
  GovernanceCustomQuestionnaireFromJSONTyped,
  GovernanceCustomQuestionnaireToJSON,
} from './GovernanceCustomQuestionnaire';

/**
 *
 * @export
 * @interface RequirementTemplate
 */
export interface RequirementTemplate {
  /**
   *
   * @type {number}
   * @memberof RequirementTemplate
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof RequirementTemplate
   */
  templateName: string;
  /**
   *
   * @type {string}
   * @memberof RequirementTemplate
   */
  templateDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof RequirementTemplate
   */
  templateType?: string;
  /**
   *
   * @type {string}
   * @memberof RequirementTemplate
   */
  version?: string;
  /**
   *
   * @type {boolean}
   * @memberof RequirementTemplate
   */
  isActive?: boolean;
  /**
   *
   * @type {string}
   * @memberof RequirementTemplate
   */
  readonly downloadUrl: string;
  /**
   *
   * @type {number}
   * @memberof RequirementTemplate
   */
  requirement: number;
  /**
   *
   * @type {GovernanceCustomQuestionnaire}
   * @memberof RequirementTemplate
   */
  readonly customQuestionnaire: GovernanceCustomQuestionnaire;
}

/**
 * Check if a given object implements the RequirementTemplate interface.
 */
export function instanceOfRequirementTemplate(value: object): value is RequirementTemplate {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('templateName' in value) || value['templateName'] === undefined) return false;
  if (!('downloadUrl' in value) || value['downloadUrl'] === undefined) return false;
  if (!('requirement' in value) || value['requirement'] === undefined) return false;
  if (!('customQuestionnaire' in value) || value['customQuestionnaire'] === undefined) return false;
  return true;
}

export function RequirementTemplateFromJSON(json: any): RequirementTemplate {
  return RequirementTemplateFromJSONTyped(json, false);
}

export function RequirementTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequirementTemplate {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    templateName: json['template_name'],
    templateDescription: json['template_description'] == null ? undefined : json['template_description'],
    templateType: json['template_type'] == null ? undefined : json['template_type'],
    version: json['version'] == null ? undefined : json['version'],
    isActive: json['is_active'] == null ? undefined : json['is_active'],
    downloadUrl: json['download_url'],
    requirement: json['requirement'],
    customQuestionnaire: GovernanceCustomQuestionnaireFromJSON(json['custom_questionnaire']),
  };
}

export function RequirementTemplateToJSON(
  value?: Omit<RequirementTemplate, 'id' | 'downloadUrl' | 'customQuestionnaire'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    template_name: value['templateName'],
    template_description: value['templateDescription'],
    template_type: value['templateType'],
    version: value['version'],
    is_active: value['isActive'],
    requirement: value['requirement'],
  };
}
